import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Specialties() {
  return <section className="bg-white py-12 sm:py-16 md:py-20 lg:py-24" data-id="element-485">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-486">
        <div className="mb-8 sm:mb-12 md:mb-16" data-id="element-487">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl md:text-5xl" data-id="element-488">
            Nuestros servicios constructivos
          </h2>
          <p className="mt-3 sm:mt-4 max-w-3xl text-base sm:text-lg md:text-xl text-gray-500" data-id="element-489">
            Nos especializamos en la construcción y habilitación de espacios
            corporativos y comerciales, adaptando cada proyecto a las
            necesidades operativas y estándares de marca de nuestros clientes.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:gap-8 lg:gap-10 lg:grid-cols-2" data-id="element-490">
          {/* Oficinas Block */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="group relative overflow-hidden rounded-[2rem] sm:rounded-[2.5rem] bg-gray-50" data-id="element-491">
            <div className="aspect-[16/9] w-full overflow-hidden" data-id="element-492">
              <img src="https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&q=80&w=1200" alt="Oficinas corporativas modernas" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-493" />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent" data-id="element-494" />
            </div>
            <div className="absolute bottom-0 left-0 p-6 sm:p-8 md:p-10 w-full" data-id="element-495">
              <h3 className="mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold text-white" data-id="element-496">
                Oficinas
              </h3>
              <ul className="space-y-2 sm:space-y-3" data-id="element-497">
                {['Habilitación corporativa', 'Remodelaciones', 'Estándares de marca'].map(item => <li key={item} className="flex items-center text-gray-200 font-medium text-sm sm:text-base" data-id="element-498">
                    <CheckCircle2 className="mr-3 h-5 w-5 text-blue-400" data-id="element-499" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Retail Block */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="group relative overflow-hidden rounded-[2rem] sm:rounded-[2.5rem] bg-gray-50" data-id="element-500">
            <div className="aspect-[16/9] w-full overflow-hidden" data-id="element-501">
              <img src="https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?auto=format&fit=crop&q=80&w=1200" alt="Espacio de retail moderno" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-502" />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent" data-id="element-503" />
            </div>
            <div className="absolute bottom-0 left-0 p-6 sm:p-8 md:p-10 w-full" data-id="element-504">
              <h3 className="mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold text-white" data-id="element-505">
                Retail
              </h3>
              <ul className="space-y-2 sm:space-y-3" data-id="element-506">
                {['Locales comerciales', 'Strip centers', 'Sucursales bancarias'].map(item => <li key={item} className="flex items-center text-gray-200 font-medium text-sm sm:text-base" data-id="element-507">
                    <CheckCircle2 className="mr-3 h-5 w-5 text-indigo-400" data-id="element-508" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}